<template>
  <v-app style="background:#F5F5F5;">
    <v-app-bar
      app
      color="#2f2116"
    >
      <v-spacer />
      <v-toolbar-items class="align-center">
        <div
          onclick="window.location='/app/signup';"
          style="cursor: pointer;border: solid 1px #da9037;color: #FFFFFF;padding: 8px 40px;margin-right: 8px; "
        >
          新規登録
        </div>
        <div
          onclick="window.location='/app/login';"
          style="cursor: pointer;border: solid 1px #da9037;color: #FFFFFF;padding: 8px 40px;background-color:#da9037;"
        >
          ログイン
        </div>
      </v-toolbar-items>
    </v-app-bar>
    <v-main>
      <div>
        <v-app-bar
          color="#F5F5F5"
          dense
          flat
          height="128px"
        >
          <div class="header-title justify-center d-flex fill-width">
            <!--      <nuxt-link to="/">
                    <img src="../assets/logomark.png" style="height:48px" />
                  </nuxt-link>-->
          </div>
        </v-app-bar>
        <v-main
          class="pa-0 fill-height"
          style="background:#F5F5F5;height: auto;"
        >
          <v-card
            :tile="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
            class="mx-auto fill-width"
            flat
            max-width="640"
          >
            <v-card-title class="text-center pa-8">
              <h4 class="fill-width">
                ログイン
              </h4>
            </v-card-title>
            <v-divider />
            <div class="px-6 py-8">
              <div
                class="mx-auto"
                style="max-width:344px"
              >
                <div>
                  <div class="pt-8 pb-4">
                    続行すると
                    <router-link
                      target="_blank"
                      to="/policy"
                    >
                      プライバシーポリシー
                    </router-link>
                    と
                    <router-link
                      target="_blank"
                      to="/terms"
                    >
                      利用規約
                    </router-link>
                    に同意したことになります。
                  </div>
                  <v-btn
                    class="fill-width text-capitalize caption"
                    height="48px"
                    outlined
                    style="border-color:#979797;"
                    tile
                    @click="googleLogin"
                  >
                    <img
                      class="button-logo-img mr-4"
                      src="https://madeby.google.com/static/images/google_g_logo.svg"
                      style="height:24px;"
                    >
                    Googleでログイン
                  </v-btn>
                  <v-btn
                    class="fill-width mt-5 text-capitalize caption"
                    color="#1DA1F2"
                    dark
                    depressed
                    height="48px"
                    tile
                    @click="twitterLogin"
                  >
                    <img
                      class="button-logo-img mr-4"
                      src="../assets/twitter_icon.png"
                      style="height:24px;"
                    >
                    Twitterでログイン
                  </v-btn>
                </div>
                <v-btn
                  class="fill-width mt-5 text-capitalize caption"
                  height="48px"
                  icon
                  style="border-color:#979797;"
                  tile
                  @click="appleLogin"
                >
                  <v-img
                    class="button-logo-img"
                    src="../assets/appleid.png"
                  />
                </v-btn>
                <div class="pt-6">
                  <v-divider />
                  <div class="pt-8 pb-4">
                    <span>アカウントをお持ちではありませんか？</span>
                    <router-link to="/signup">
                      アカウント新規登録に移動
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-main>
        <footer style="background: #F5F5F5">
          <div class="pa-8 d-flex flex-warp justify-center fill-wdith">
            <!--        <nuxt-link to="privacy" class="link-caption mr-8">プライバシーポリシー</nuxt-link>-->
            <!--        <nuxt-link to="tos" class="link-caption mr-8">利用規約</nuxt-link>-->
            <router-link
              class="link-caption mr-8"
              target="_blank"
              to="/policy"
            >
              プライバシーポリシー
            </router-link>
            <router-link
              class="link-caption mr-8"
              target="_blank"
              to="/terms"
            >
              利用規約
            </router-link>
            <router-link
              class="link-caption mr-8"
              target="_blank"
              to="/tokushou"
            >
              特定商取引法に基づく表示
            </router-link>
          </div>
        </footer>
      </div>
    </v-main>
    <v-overlay :value="progress">
      <v-progress-circular
        :indeterminate="true"
        color="primary"
      />
    </v-overlay>
  </v-app>
</template>

<script>
import firebase from "firebase/app"
import router from "@/router";

export default {
  data() {
    return {
      progress:false
    }
  },
  methods: {
    googleLogin: function () {
      const provider = new firebase.auth.GoogleAuthProvider()
      this.progress=true;
      firebase.auth().signInWithPopup(provider).then(result => {
        this.$store.dispatch("userModule/getUser", {showDialog: true, autoCreate: false}).then(value => {
          this.progress=false;
              router.push('/novels')
            }
        );
      }).catch(error => {
        this.progress=false;
        this.errorMessage = error.message
        this.showError = true
      })
    },
    twitterLogin: function () {
      const provider = new firebase.auth.TwitterAuthProvider()
      this.progress=true;
      firebase.auth().signInWithPopup(provider).then(result => {
        // this.saveAuth(result.user)
        // eslint-disable-next-line no-unused-vars
        this.$store.dispatch("userModule/getUser", {showDialog: true, autoCreate: false}).then(value => {
          this.progress=false;
              router.push('/novels')
            }
        );
      }).catch(error => {
        this.progress=false;
        this.errorMessage = error.message
        this.showError = true
      })
    },
    appleLogin: function () {
      const provider = new firebase.auth.OAuthProvider('apple.com')
      this.progress=true;

      firebase.auth().signInWithPopup(provider).then(result => {
        // this.saveAuth(result.user)
        // eslint-disable-next-line no-unused-vars

        this.$store.dispatch("userModule/getUser", {showDialog: true, autoCreate: false}).then(value => {
          this.progress=false;
              router.push('/novels')
            }
        );
      }).catch(error => {
        this.progress=false;
        this.errorMessage = error.message
        this.showError = true
      })
    },
  }

}
</script>
<style scoped>
.fill-width {
  width: 100%;
}

.link-caption {
  text-decoration: none;
  color: #666 !important;
  font-size: .75rem;
}

.separator {
  margin-top: 30px;
  margin-bottom: 30px;
  height: 0;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #fff;
  position: relative;
}

.middle_separator {
  position: absolute;
  padding: 0 16px;
  color: #ccc;
  background: #fff;
  font-size: 11px;
  text-shadow: 0 1px 0 #fff;
  text-transform: uppercase;
  top: -7px;
  left: 30%;
}

.middle_separator {
  color: #777;
  font-size: 13px;
  top: -9px;
  left: 41%;
}
</style>